import { useMemo } from "react";
import { MapContainer, TileLayer, Marker, Tooltip } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { STATUS_LABEL } from "./jobsShared";

const COLOR = { in_progress: "#FF5F15", planned: "#2565bd", on_hold: "#d97706", completed: "#19854b" };
const pin = (status) => L.divIcon({ className: "", iconSize: [22, 22], iconAnchor: [11, 11],
  html: `<span style="display:block;width:22px;height:22px;border-radius:50%;background:${COLOR[status] || "#64748b"};border:3px solid #fff;box-shadow:0 2px 6px #0005"></span>` });

const valid = (j) => Number.isFinite(Number(j.site_lat)) && Number.isFinite(Number(j.site_lng)) && Number(j.site_lat) !== 0 && Math.abs(Number(j.site_lat)) <= 90 && Math.abs(Number(j.site_lng)) <= 180;

export function JobsMap({ jobs, navigate }) {
  const plotted = useMemo(() => jobs.filter(valid), [jobs]);
  const bounds = plotted.length ? L.latLngBounds(plotted.map((j) => [Number(j.site_lat), Number(j.site_lng)])).pad(0.2) : null;
  return (
    <div data-testid="jr-map-view">
      <p className="jr-muted mb-2" data-testid="jr-map-count">{plotted.length} of {jobs.length} matching jobs have a mapped site location.</p>
      <div className="jr-map">
        <MapContainer key={plotted.map((j) => j.id).join()} bounds={bounds || undefined} center={bounds ? undefined : [-36.8485, 174.7633]} zoom={bounds ? undefined : 10} className="w-full h-full">
          <TileLayer attribution="&copy; OpenStreetMap contributors" url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" referrerPolicy="strict-origin-when-cross-origin" />
          {plotted.map((j) => (
            <Marker key={j.id} position={[Number(j.site_lat), Number(j.site_lng)]} icon={pin(j.status)} eventHandlers={{ click: () => navigate(`/app/jobs/${encodeURIComponent(j.id)}`) }}>
              <Tooltip>{j.job_number ? `${j.job_number} · ` : ""}{j.title}<br />{STATUS_LABEL[j.status] || j.status}</Tooltip>
            </Marker>
          ))}
        </MapContainer>
      </div>
    </div>
  );
}
